import React, {Component} from "react";
import {configVariantSales, configVariantSalesYearToDate} from "../config";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import * as R from "ramda";
import Api from "../../../../../Services/Api";
import {fetchDataAsync} from "../../../../../Services/Utils";
import {HttpStatus} from "../../../../common/Constants";

class VariantSalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableConfig: [],
            dataTable: [],
        };
    };

    componentDidMount() {
        this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: this.props.tab === "variant"
                ? configVariantSales
                : this.props.tab === "ytd"
                    ? configVariantSalesYearToDate(this.props.search?.year)
                    : [],
        }));
    };

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch === true) {
            if(this.props.tab === "ytd"){
                this.setState({tableConfig: configVariantSalesYearToDate(this.props.search?.year)})
            }
            await this.fetchData(this.props.search);
            this.props.handleSetValue("doSearch", false);
        }
    }

    fetchData = async (payload) => {
        this.props.triggerLoading();
        let url = R.equals(this.props.tab, "variant")
            ? Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerVariantKacab
            : R.equals(this.props.tab, "ytd")
                ? Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerVariantYTD
                : null;
        let res = await fetchDataAsync({
            asyncFn: url,
            menuName: "Dashboard Level Team Leader - Laporan Jual Varian",
            setError: this.props.setError,
            args: payload,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS && !R.isNil(res.data.data)) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
            }));
        }
        this.props.triggerLoading();
    }

    render() {
        return (
            <>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    toCount={0}
                    rowsPerPage={10}
                    page={0}
                />
            </>
        );
    };
}

export default VariantSalesReport;